/**
 * List module.
 * @module video/List
 */

import './style.css';
import tmpl from './main.ejs';
import Events from 'f.core.event';
import Util from 'f.core.util.pc';
const pcVideoUtil = new Util();

/**
 * 全屏时，列表组件
 */
class List {
    /**
     * Creates an instance of List.
     * @param {object} obj
     * @param {object} obj.videoinfo video相关信息
     * @param {object} obj.sedata 列表相关数据
     * @param {object} container 容器
     */
    constructor({
        videoinfo,
        sedata = [],
        container,
    }) {
        this.videoinfo = videoinfo;
        this.sedata = sedata;
        this.container = container;
        this.state = false;
        // this.init();
    }

    /**
     * 初始化快捷方法
     */
    initShow() {
        if (!this.state) {
            this.state = true;
            this.init();
            this.renderTo(this.container);
        }

        this.show();
    }

    /**
     * 初始化
     */
    init() {
        this.initDom();
        this.initCompontent();
        this.getCommentCount();
        this.initEvent();
    }

    /**
     * 初始化dom
     */
    initDom() {
        this.el = $(tmpl())[0];
        // this.share = $(this.el).find('#js_siderRight_share');
        this.shareBtns = $(this.el).find('.shareBtns');
        this.copyBtns = $(this.el).find('.copyBtns');

        // this.download = $(this.el).find('#js_siderRight_down');

        // this.list = $(this.el).find('#js_siderRight_menu');

        this.listul = $(this.el).find('#js_siderRight_list');
        // js_listPosition
        // this.listdiv = this.el.getElementsByClassName('listPosition')[0];
        // js_siderRight_list

        // js_siderRight_scroller
        // this.listscroll = this.el.getElementsByClassName('scroller')[0];

        this.close = $(this.el).find('#js_siderRight_close');

        // 复制
        this.copyText = $(this.el).find('#js_copy_text');
        // 二维码
        this.js_siderRight_shareImg = $(this.el).find('#js_siderRight_shareImg');
    }

    /**
     * 初始化component
     */
    initCompontent() {
        let listStr = '';
        for (let vi = 0, vl = this.sedata.length; vi < vl; vi++) {
            const _sedata = this.sedata[vi];
            const _class = videoinfo.vid == _sedata.id ? 'class=current' : '';
            listStr += `
                <li ${_class} data-vid="${_sedata.id}">
                    <a href="${_sedata.link}">
                        <img src="${_sedata.img}" />
                        <i></i>
                        <span class="time">${pcVideoUtil.formatTime(_sedata.duration || 0)}</span>
                        <em>${_sedata.text}</em>
                    </a>
                </li>
            `;
        }
        this.listul.html(listStr);
    }

    /**
     * 请求微信分享二维码图片
     */
    getCommentCount() {
        const _this = this;
        if (typeof videoinfo !== "undefined" && typeof videoinfo.vid !== "undefined") {
            //    微信分享请求二维码
            const mUrl = videoinfo.mUrl;
            $.ajax({
                url: 'http://qrcode.ifeng.com/qrcode.php',
                cache: true,
                dataType: 'jsonp',
                data: {
                    url: `${mUrl}?_share=weixin`
                },
                success(r) {
                    _this.js_siderRight_shareImg.attr('src', r.qrcode_url);
                }
            });
        }
    }

    /**
     * 初始化自定义事件
     */
    initEvent() {
        const _this = this;
        const videoinfo = _this.videoinfo;

        /**
         * 关闭按钮点击事件
         */
        this.close.on('click', () => {
            _this.hide();
        });

        /**
         * 分享按钮点击事件
         */
        this.shareBtns.on('click', e => {
            const ev = e || window.event;
            const target = ev.target || ev.srcElement;
            if (target.nodeName.toLowerCase() == 'li') {
                if (target.className == 'current') return;
                let _sendcode = null;
                const tag = target.getAttribute('data-tag');
                switch (tag) {
                    case 'sinateew':
                        _sendcode = 503004;
                        pcVideoUtil.sendStatisticInfoC('sina');
                        pcVideoUtil.shareVideo('sinateew');
                        break;
                    case 'qqteew':
                        _sendcode = 5030022;
                        pcVideoUtil.sendStatisticInfoC('qq');
                        pcVideoUtil.shareVideo('qqteew');
                        break;
                    case 'qqzone':
                        _sendcode = 503002;
                        pcVideoUtil.sendStatisticInfoC('qqZone');
                        pcVideoUtil.shareVideo('qqzone');
                        break;
                }
                /** 分享发送统计 */
                _this.trigger('sendVplayer', _sendcode);
            }
        });

        /**
         * 复制按钮点击事件
         */
        this.copyBtns.on('click', e => {
            const ev = e || window.event;
            const target = ev.target || ev.srcElement;
            if (target.nodeName.toLowerCase() == 'li') {
                if (target.className == 'current') return;
                const tag = target.getAttribute('data-tag');
                switch (tag) {
                    case 'url':
                        const _urlText = videoinfo.url;
                        _this.copy(_urlText, target);
                        break;
                    case 'mp4':
                        const _mp4Text = `http://v.ifeng.com/include/exterior.swf?guid=${videoinfo.id}&AutoPlay=false`;
                        _this.copy(_mp4Text, target);
                        break;
                    case 'html':
                        const _htmlText = `<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=7,0,19,0" width="400" height="325"><param name="movie" value="http://v.ifeng.com/include/exterior.swf?guid=${videoinfo.id}&pageurl=http://www.ifeng.com&fromweb=other&AutoPlay=false" /><param name="quality" value="high" /><param name="allowScriptAccess" value="always" /><embed src="http://v.ifeng.com/include/exterior.swf?guid=${videoinfo.id}&pageurl=http://www.ifeng.com&fromweb=other&AutoPlay=false" quality="high"  allowScriptAccess="always" pluginspage="http://www.macromedia.com/go/getflashplayer" type="application/x-shockwave-flash" width="400" height="325"></embed></object>`;
                        _this.copy(_htmlText, target);
                        break;
                }
            }
        });
        // this.addScroll();
    }

    /**
     * 复制内容
     *
     * @param {string} txt 文本内容
     * @param {HTMLELEMENT} ele 元素载体
     */
    copy(txt, ele) {
        // this.el.style.display = 'none';
        const preText = ele.innerHTML; // 存起来
        this.copyText.html(txt);
        this.copyText.select();
        document.execCommand('Copy');
        $(ele).html('√复制成功');
        $(ele).addClass('selected');
        setTimeout(() => {
            ele.innerHTML = preText;
            $(ele).removeClass('selected');
        }, 1000);
        const old = $(ele).siblings();

        $(old[0]).removeClass('selected').html($(old[0]).attr('data-text'));
        $(old[1]).removeClass('selected').html($(old[1]).attr('data-text'));
        console.log($(old[0]).attr('data-text'));
        console.log($(old[1]).attr('data-text'));
        this.trigger('sendVplayer', 504000);
    }

    /**
     * 隐藏组件
     */
    hide() {
        this.el.style.display = 'none';
    }

    /**
     * 显示组件
     */
    show() {
        this.el.style.display = 'block';
    }

    /**
     * 渲染组件
     *
     * @param {HTMLELEMENT} parentNode
     */
    renderTo(parentNode) {
        parentNode.appendChild(this.el);
    }
}

Events.mixTo(List);
export default List;


// WEBPACK FOOTER //
// ./components/f.component.video.pc/app/modules/list/index.js